import axios from 'axios';

const getNfcPos = async (token) => {
  try {
    const tagsRes = await axios.get('/Pos/all', {
      headers: {
        baseUrl: process.env.REACT_APP_BASE_URL,
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token
      }
    });
    return tagsRes;
  } catch (error) {
    return error;
  }
};
export default getNfcPos;
